(function() {

	var scrollOptions = {
	  speed: 200,
	};

	var backToTopButton = document.querySelector('.scroll-to-top');


	var body = document.querySelector('body');
	var scrollPosition = false;


	backToTopButton.addEventListener('click', scrollToTop);

	window.addEventListener('scroll', onScroll);


	function scrollToTop(domEvent){
		domEvent.stopPropagation();
		animateScrollTo(0, scrollOptions);
	}

	function onScroll() {
		requestAnimationFrame(function() {

  			var newScrollPosition = window.pageYOffset;

			if (scrollPosition === newScrollPosition) {
				return;
			}
			scrollPosition = newScrollPosition;

			toggleVisibilityOfScrollToTopButton();
		});
	}

	function toggleVisibilityOfScrollToTopButton() {
		if (window.pageYOffset < (window.innerHeight * 1.5)) {
			body.classList.remove('show-scroll-to-top');
			return;
		}

		body.classList.add('show-scroll-to-top');
	}

	toggleVisibilityOfScrollToTopButton();

}());
